import React, {Component } from 'react';
import { Breadcrumb, Card,Divider,Button,DatePicker,Spin,Empty,Modal } from 'antd';
import { DashboardOutlined, FilePdfOutlined,SendOutlined,FileSearchOutlined, DoubleRightOutlined} from '@ant-design/icons';
import {Row, Col} from 'react-bootstrap';
import moment from 'moment';
import mHelper from './../../config/Helper';
import mDownloadControllers from './../../control/download/index.controllers';
import HeaderTitle from '../../component/HeaderTitle/HeaderTitle'
var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

const { Meta } = Card;
var thisComponent;
class DocumentB extends Component {

    constructor(props) {
        super(props);
        this.state = {
            AdCode : isLogin.company.ad_code,
            AdName : isLogin.company.ad_name,
            Periode: mHelper.GET_DATE_DIGIPOS(),
            loadingDocumentB : false,
            dataDocInvoice: [],
            dataDocInvoiceSign: [],
            dataDocBar:[],
            dataDocFp:[],
            dataSummary : []
        };
        thisComponent = this;
    }

    async componentDidMount() {
        this.onGetDocB();
    }


    onChangeDate = (date, dateString) => {
        this.setState({Periode:dateString});
    }

    onGetDocB = () => {
        this.setState({loadingDocumentB : true});
        mDownloadControllers.GET_DOCUMENT_B(this.state.Periode,(r)=>{
            this.setState({loadingDocumentB : false,dataDocBar : r.dataBar, dataDocInvoice : r.dataInvoice, dataDocInvoiceSign : r.dataInvoiceSign, dataDocFp : r.dataFp, dataSummary : r.dataSummary});
        });
    }

    onProcessDocumentB = () =>{
        this.onGetDocB();
    }

    onViewDocBar = (name) =>{
        mDownloadControllers.VIEW_DOC_BAR(name,(r)=>{
            // console.log(r);
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>File tidak bisa ditemukan !</p>
                      </div>
                    ),
                    onOk() {},
                });
            }
        });
    }

    onViewDocFp = (name) =>{
        mDownloadControllers.VIEW_DOC_FAKTUR_PAJAK(name,(r)=>{
            // console.log(r);
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>File tidak bisa ditemukan !</p>
                      </div>
                    ),
                    onOk() {},
                });
            }
        });
    }

    onViewDocInvoice = (name) =>{
        mDownloadControllers.VIEW_DOC_INVOICE(name,(r)=>{
            // console.log(r);
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>File tidak bisa ditemukan !</p>
                      </div>
                    ),
                    onOk() {},
                });
            }
        });
    }
    
    onViewDocInvoiceSign = (name) =>{
        mDownloadControllers.VIEW_DOC_INVOICE_SIGN(name,(r)=>{
            // console.log(r);
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>File tidak bisa ditemukan !</p>
                      </div>
                    ),
                    onOk() {},
                });
            }
        });
    }
    render(){
        return (
            <div >
                <Breadcrumb>
                    <Breadcrumb.Item>
                    <div className="TitlePage">
                        <DashboardOutlined className="icon" /><DoubleRightOutlined className="iconArrow" /> <h3>Document AD B</h3>
                    </div>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row>
                <HeaderTitle onChangeDate={this.onChangeDate} onProcess={this.onProcessDocumentB} momen={moment(this.state.Periode, 'YYYY-MM')}/>
                    <Col sm={12}  lg={12} style={{marginBottom:20}}>
                        <Spin spinning={this.state.loadingDocumentB} >
                            <Card bordered={false} className="box" style={{textAlign:"left"}}>
                                <Divider orientation="left">DOCUMENT BAR RECON PERIODE {this.state.Periode}</Divider>
                                {this.state.dataDocBar.length === 0 ? <Empty /> : (
                                    <Row>
                                        {this.state.dataDocBar.map((bar,index) => (
                                            <Col sm={4} key={index} lg={4} style={{marginBottom:10}}>
                                                <Card 
                                                    actions={[
                                                        <Button type="text" key="view-bar" onClick={event => {this.onViewDocBar(bar.name)} }><FileSearchOutlined/> VIEW DOCUMENT</Button>
                                                    ]}
                                                >
                                                    <Meta
                                                        avatar={
                                                            <FilePdfOutlined style={{color : '#29647B'}}/>
                                                        }
                                                        title="BAR B Recon"
                                                        description={"Nomor : "+bar.no_bar}
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Card>
                        </Spin>
                    </Col>

                    <Col sm={12}  lg={12} style={{marginBottom:20}}>
                        <Spin spinning={this.state.loadingDocumentB} >
                            <Card bordered={false} className="box" style={{textAlign:"left"}}>
                                <Divider orientation="left">DOCUMENT SUMMARY PERIODE {this.state.Periode}</Divider>
                                {this.state.dataSummary.length === 0 ? <Empty /> : (
                                    <Row>
                                        {this.state.dataSummary.map((bar,index) => (
                                            <Col sm={4} key={index} lg={4} style={{marginBottom:10}}>
                                                <Card 
                                                    actions={[
                                                        <Button type="text" key="view-bar" onClick={event => {this.onViewDocBar(bar.name)} }><FileSearchOutlined/> VIEW DOCUMENT</Button>
                                                    ]}
                                                >
                                                    <Meta
                                                        avatar={
                                                            <FilePdfOutlined style={{color : '#29647B'}}/>
                                                        }
                                                        title={bar.no_bar}
                                                        description={"Nomor : "+bar.no_bar}
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Card>
                        </Spin>
                    </Col>

                    <Col sm={12}  lg={12} style={{marginBottom:20}}>
                        <Spin spinning={this.state.loadingDocumentB} >
                            <Card bordered={false} className="box" style={{textAlign:"left"}}>
                                <Divider orientation="left">DOCUMENT INVOICE PERIODE {this.state.Periode}</Divider>
                                {this.state.dataDocInvoice.length === 0 && this.state.dataDocInvoiceSign.length === 0? <Empty /> : (
                                    <Row>
                                        {this.state.dataDocInvoice.map((bar,index) => (
                                            <Col sm={4} key={index} lg={4} style={{marginBottom:10}}>
                                                <Card 
                                                    actions={[
                                                        <Button type="text" key="view-bar" onClick={event => {this.onViewDocInvoice(bar.name)} }><FileSearchOutlined/> VIEW DOCUMENT</Button>
                                                    ]}
                                                >
                                                    <Meta
                                                        avatar={
                                                            <FilePdfOutlined style={{color : '#29647B'}}/>
                                                        }
                                                        title="PAID INVOICE"
                                                        description={"Nomor : "+bar.no_inv}
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                        {this.state.dataDocInvoiceSign.map((bar,index) => (
                                            <Col sm={4} key={index} lg={4} style={{marginBottom:10}}>
                                                <Card 
                                                    actions={[
                                                        <Button type="text" key="view-bar" onClick={event => {this.onViewDocInvoiceSign(bar.name)} }><FileSearchOutlined/> VIEW DOCUMENT</Button>
                                                    ]}
                                                >
                                                    <Meta
                                                        avatar={
                                                            <FilePdfOutlined style={{color : '#29647B'}}/>
                                                        }
                                                        title="PAID INVOICE SIGN"
                                                        description={"Nomor : "+bar.no_inv}
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Card>
                        </Spin>
                    </Col>

                    <Col sm={12}  lg={12} style={{marginBottom:20}}>
                        <Spin spinning={this.state.loadingDocumentB} >
                            <Card bordered={false} className="box" style={{textAlign:"left"}}>
                                <Divider orientation="left">DOCUMENT FAKTUR PAJAK PERIODE {this.state.Periode}</Divider>
                                {this.state.dataDocFp.length === 0 && this.state.dataDocFp.length === 0? <Empty /> : (
                                    <Row>
                                        {this.state.dataDocFp.map((bar,index) => (
                                            <Col sm={4} key={index} lg={4} style={{marginBottom:10}}>
                                                <Card 
                                                    actions={[
                                                        <Button type="text" key="view-bar" onClick={event => {this.onViewDocFp(bar.name)} }><FileSearchOutlined/> VIEW DOCUMENT</Button>
                                                    ]}
                                                >
                                                    <Meta
                                                        avatar={
                                                            <FilePdfOutlined style={{color : '#29647B'}}/>
                                                        }
                                                        title="FAKTUR PAJAK"
                                                        description={"Nomor : "+bar.no_vat}
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Card>
                        </Spin>
                    </Col>

                </Row>
            </div>
        )
    }
}


export default DocumentB;
